import api from './api';

/**
 * Tek dosya yükler → MinIO public URL döner.
 * Kabul edilen: JPEG, PNG, GIF, WEBP, GLB (3D/AR), USDZ (AR), PDF
 */
export async function uploadMedia(file) {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post('/Upload/Image', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data.url;
}

/**
 * Birden fazla dosya yükler → URL dizisi döner.
 */
export async function uploadMediaFiles(files) {
  const form = new FormData();
  files.forEach(f => form.append('files', f));
  const res = await api.post('/Upload/Images', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data; // string[]
}
